
Promise.all([import('./tab-see-and-do.scss')]).then(() =>
{
  $('.widget.tab-see-and-do').each(function (i, el) {
    $(el).data('widget', new TabSeeAndDo(el))
    $(el).data('widget').init()
  })
})

function TabSeeAndDo(el) {
  const self = this
  self.el = $(el)
  self.isLoaded = false

  // Determine which results template we use
  const isDhpTheme = $('html').hasClass('dhp-theme') || $('body').hasClass('dhp-theme')
  if (isDhpTheme) {
    self.seeAndDoResults = require('./tab-see-and-do--dhp.hbs')
  } else {
    self.seeAndDoResults = require('./tab-see-and-do--gday.hbs')
  }

  self.render = function (data) {
    // Add `datesMatch` data to each result, used to display dates in handlebars template
    $.each(data.Results, function (i, result) {
      data.Results[i].DatesMatch = result.StartDate === result.EndDate
    })

    const html = self.seeAndDoResults({ data })
    self.el.find('.results').append(html)
  }

  self.loadContent = function () {
    if (self.isLoaded) {
      return
    }

    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        if (data.success) {
          self.render(data)
        } else {
          // If there is no tab content to show, remove the tab from the page
          const name = self.el.parents('.tab-content').attr('data-tab')
          window.dbs.globalEvents.emit('remove_tab', name, true)
        }

        self.isLoaded = true
        window.dbs.globalEvents.emit('tab_loaded', null, true)
      })
      .fail(function () {
        // TODO decide what happens on fail
        sendLog("ERROR", "Failed to load Tab See and Do info", JSON.stringify({ 'url': $(el).attr('data-endpoint'), "type": $(el).attr('data-method') }));
      })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('TabSeeAndDo init', self)
    }
    self.el.css('opacity', 1)
    
    sendLog('INFO', 'See and Do Content Loaded', JSON.stringify({ 'node_env': process.env.NODE_ENV }));

    self.loadContent()

    window.dbs.globalEvents.subscribe('was_tab_loaded', function () {
      if (self.isLoaded) {
        window.dbs.globalEvents.emit('tab_loaded', null, true)
      }
    })
  }
}
